const eventConfig = { conference: 'rootstech-2025' }
export default eventConfig
